const query = (state = {
  query: {
    name: '', limit: 10, offset: 0,
  },
}, action) => {
  switch (action.type) {
    case 'SET_QUERY':
      return {
        query: action.query,
      };
    default:
      return state;
  }
};
export default query;
